// dna_frontend/src/pages/BaoCao.js
// (Copy và thay thế toàn bộ file)

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { 
    Box, Tabs, Tab, TextField, Button, Typography, 
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    Alert, TableFooter 
} from '@mui/material';
import FileSaver from 'file-saver';
import './BaoCao.css';


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`bao-cao-tabpanel-${index}`}
      aria-labelledby={`bao-cao-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}
const getTodayLocalString = () => {
    const today = new Date();
    const y = today.getFullYear();
    const m = String(today.getMonth() + 1).padStart(2, '0');
    const d = String(today.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

function BaoCao() {
  const [tabValue, setTabValue] = useState(0); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const [tuNgay, setTuNgay] = useState(getTodayLocalString()); 
  const [denNgay, setDenNgay] = useState(getTodayLocalString());
  
  const [ketQuaData, setKetQuaData] = useState({ byXa: [] });
  // (*** MỚI (Yêu cầu) ***)
  const [totalDaThuTrongKy, setTotalDaThuTrongKy] = useState(0);

  const [theoDoiRaSoatData, setTheoDoiRaSoatData] = useState({ data: [], totals: null }); 
  const [duBaoData, setDuBaoData] = useState([]);
  const [loadingDuBao, setLoadingDuBao] = useState(false);
  
  const fetchKetQuaHangNgay = async (dateFrom, dateTo) => {
      setLoading(true);
      setError('');
      try {
          const res = await api.get(`/bao-cao/ket-qua-hang-ngay?tu_ngay=${dateFrom}&den_ngay=${dateTo}`);
          setKetQuaData(res.data);
          
          // (*** MỚI (Yêu cầu) ***) Tính tổng
          if (res.data.byXa && res.data.byXa.length > 0) {
              const total = res.data.byXa.reduce((acc, xa) => acc + xa.DaThu, 0);
              setTotalDaThuTrongKy(total);
          } else {
              setTotalDaThuTrongKy(0);
          }
          
      } catch (err) {
          console.error(err);
          setError(err.response?.data?.message || 'Lỗi tải Báo cáo Kết quả (Tab 1)');
      } finally {
          setLoading(false);
      }
  };

  const fetchTheoDoiRaSoat = async (dateFrom, dateTo) => {
      setLoading(true);
      setError('');
      try {
          const res = await api.get(`/bao-cao/theo-doi-xa?tu_ngay=${dateFrom}&den_ngay=${dateTo}`);
          setTheoDoiRaSoatData(res.data); 
      } catch (err) {
          console.error(err);
          setError(err.response?.data?.message || 'Lỗi tải Báo cáo Rà soát (Tab 2)');
      } finally {
          setLoading(false);
      }
  };
  
  const fetchDuBao = async (dateFrom, dateTo) => {
      setLoadingDuBao(true);
      setError('');
      try {
          let url = '/bao-cao/du-bao';
          if (dateFrom && dateTo) {
              url += `?tu_ngay=${dateFrom}&den_ngay=${dateTo}`;
          }
          const res = await api.get(url);
          setDuBaoData(res.data);
      } catch (err) { 
          console.error(err);
          setError(err.response?.data?.message || 'Lỗi tải Dự báo (Tab 3)');
      } finally {
          setLoadingDuBao(false);
      }
  };
  
  useEffect(() => {
    fetchKetQuaHangNgay(tuNgay, denNgay); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); 

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setError(''); 
    
    if (newValue === 0) {
        fetchKetQuaHangNgay(tuNgay, denNgay);
    } else if (newValue === 1) {
        fetchTheoDoiRaSoat(tuNgay, denNgay);
    } else if (newValue === 2) {
        fetchDuBao(tuNgay, denNgay);
    }
  };
  
  const handleSearch = () => {
      if (!tuNgay || !denNgay) {
          setError("Vui lòng chọn 'Từ ngày' và 'Đến ngày'.");
          return;
      }
      if (tabValue === 0) {
          fetchKetQuaHangNgay(tuNgay, denNgay);
      } else if (tabValue === 1) {
          fetchTheoDoiRaSoat(tuNgay, denNgay); 
      } else if (tabValue === 2) {
          fetchDuBao(tuNgay, denNgay); 
      }
  };
  
  const handleExportExcel = async () => {
      setLoading(true);
      setError('');
      try {
          const response = await api.get(
              `/bao-cao/export-ket-qua-hang-ngay?tu_ngay=${tuNgay}&den_ngay=${denNgay}`, 
              {
                  responseType: 'blob', 
              }
          );
          FileSaver.saveAs(response.data, `BaoCao_${tuNgay}_den_${denNgay}.xlsx`);
      } catch (err) {
          console.error(err);
          setError("Lỗi khi xuất file Excel.");
      } finally {
          setLoading(false);
      }
  };
  
  const handleSetDuBao = async (lichId, ngay, soLuong) => {
      const soLuongNum = parseInt(soLuong);
      if (isNaN(soLuongNum) || soLuongNum < 0) {
          alert("Vui lòng nhập số lượng dự kiến là một số hợp lệ.");
          return;
      }
      try {
          const formattedDate = new Date(ngay).toISOString().split('T')[0];
          await api.post('/bao-cao/du-bao', {
              lich_thu_mau_id: lichId,
              ngay_du_bao: formattedDate, 
              so_luong_du_kien: soLuongNum
          });
          setDuBaoData(duBaoData.map(item => 
              (item.id === lichId && new Date(item.ngay_thu).toISOString().split('T')[0] === formattedDate) 
              ? { ...item, soLuongDuKien: soLuongNum } 
              : item
          ));
      } catch (err) {
           alert("Lỗi khi cập nhật dự báo: " + (err.response?.data?.message || err.message));
      }
  };
  const handleDuBaoChange = (lichId, ngay, newValue) => {
      const soLuong = prompt(`Thiết lập số lượng dự kiến cho ngày ${new Date(ngay).toLocaleDateString('vi-VN')} (Lịch ID ${lichId}):`, newValue || 0);
      if (soLuong !== null) { 
          handleSetDuBao(lichId, ngay, soLuong);
      }
  };


  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h4" gutterBottom>Theo dõi Hằng ngày & Báo cáo</Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="Báo cáo tabs">
          <Tab label="1. Báo cáo Kết quả (Theo ngày)" id="bao-cao-tab-0" />
          <Tab label="2. Theo dõi rà soát (Theo lịch)" id="bao-cao-tab-1" />
          <Tab label="3. Dự báo số mẫu thu (Theo lịch)" id="bao-cao-tab-2" />
        </Tabs>
      </Box>
      
      <Box sx={{ p: 2, background: '#f9f9f9', display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <TextField
          label="Từ ngày"
          type="date"
          value={tuNgay}
          onChange={(e) => setTuNgay(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{minWidth: 160}}
        />
        <TextField
          label="Đến ngày"
          type="date"
          value={denNgay}
          onChange={(e) => setDenNgay(e.target.value)}
          InputLabelProps={{ shrink: true }}
           sx={{minWidth: 160}}
        />
        <Button 
          variant="contained" 
          onClick={handleSearch} 
          disabled={loading || loadingDuBao}
        >
          Tra cứu
        </Button>
      </Box>

      {error && <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>}

      {/* --- TAB 1: BÁO CÁO KẾT QUẢ --- */}
      <TabPanel value={tabValue} index={0}>
        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2}}>
            <Typography variant="h6">
              Báo cáo Kết quả (Từ {tuNgay} đến {denNgay})
            </Typography>
            <Button variant="contained" color="success" onClick={handleExportExcel} disabled={loading}>
              Xuất Excel
            </Button>
        </Box>
        
        {loading && <p>Đang tải...</p>}
        
        {/* (*** MỚI (Yêu cầu) ***) Ô Tổng */}
        {!loading && (
             <Paper sx={{ p: 2, textAlign: 'center', background: '#eafaf1', mb: 2, maxWidth: '300px' }}>
                <Typography variant="h3">{totalDaThuTrongKy}</Typography>
                <Typography variant="body1">Tổng Đã thu (Trong khoảng)</Typography>
              </Paper>
        )}
        
        {/* (*** SỬA (Yêu cầu) ***) Lọc `xa.DaThu > 0` */}
        {!loading && (
            <TableContainer component={Paper} sx={{ mt: 2 }} className="table-wrapper-baocao">
                <Table stickyHeader className="responsive-table-baocao">
                  <TableHead>
                    <TableRow>
                      <TableCell rowSpan="2">STT</TableCell>
                      <TableCell rowSpan="2">Tên Xã</TableCell>
                      <TableCell rowSpan="2">Tổng số</TableCell>
                      <TableCell colSpan="6" sx={{textAlign: 'center', background: '#fff8e1'}}>Không thu mẫu đợt này</TableCell>
                      <TableCell rowSpan="2">Tổng cần thu</TableCell>
                      <TableCell rowSpan="2">Đã thu (Trong kỳ)</TableCell>
                      <TableCell rowSpan="2">Tỷ lệ (Trong kỳ)</TableCell>
                      <TableCell rowSpan="2">Chưa thu (Toàn bộ)</TableCell>
                      <TableCell rowSpan="2">Chưa có LS</TableCell>
                    </TableRow>
                    <TableRow className="sub-header">
                      <TableCell sx={{background: '#fff8e1'}}>KLL</TableCell>
                      <TableCell sx={{background: '#fff8e1'}}>KNC</TableCell>
                      <TableCell sx={{background: '#fff8e1'}}>Ở xa</TableCell>
                      <TableCell sx={{background: '#fff8e1'}}>Thu trước</TableCell>
                      <TableCell sx={{background: '#fff8e1'}}>Dự phòng</TableCell>
                      <TableCell sx={{background: '#fff8e1'}}>Đề nghị xóa</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ketQuaData.byXa.filter(xa => xa.DaThu > 0).length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={14} sx={{textAlign: 'center'}}>
                                Không có xã nào phát sinh số thu mẫu trong khoảng ngày đã chọn.
                            </TableCell>
                        </TableRow>
                    ) : (
                        ketQuaData.byXa
                          .filter(xa => xa.DaThu > 0) // (LỌC)
                          .map((xa, index) => (
                          <TableRow key={xa.xa_id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell sx={{fontWeight: 'bold', textAlign: 'left'}}>{xa.ten_xa}</TableCell>
                            <TableCell>{xa.TongSo}</TableCell>
                            <TableCell>{xa.KhongThu_KLL}</TableCell>
                            <TableCell>{xa.KhongThu_KNC}</TableCell>
                            <TableCell>{xa.KhongThu_OXKV}</TableCell>
                            <TableCell>{xa.KhongThu_Truoc}</TableCell>
                            <TableCell>{xa.KhongThu_DuPhong}</TableCell>
                            <TableCell>{xa.KhongThu_DeNghiXoa}</TableCell>
                            <TableCell sx={{ background: '#eaf8fa' }}>{xa.TongCanThu}</TableCell>
                            <TableCell sx={{ background: '#eafaf1' }}>{xa.DaThu}</TableCell>
                            <TableCell sx={{ background: '#eafaf1' }}>{xa.TyLeDaThu.toFixed(2)}%</TableCell>
                            <TableCell sx={{ color: 'red', fontWeight: 'bold' }}>
                              {xa.ChuaThu}
                            </TableCell>
                            <TableCell sx={{ color: xa.ChuaCoLietSi > 0 ? 'red' : 'inherit' }}>
                              {xa.ChuaCoLietSi}
                            </TableCell>
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
            </TableContainer>
        )}
      </TabPanel>

      {/* --- TAB 2: THEO DÕI XÃ --- */}
      {/* (Giữ nguyên từ code cũ) */}
      <TabPanel value={tabValue} index={1}>
        <Typography variant="h6">Báo cáo Rà soát (Theo lịch thu từ {new Date(tuNgay + 'T00:00:00').toLocaleDateString('vi-VN')} đến {new Date(denNgay + 'T00:00:00').toLocaleDateString('vi-VN')})</Typography>
        {loading && <p>Đang tải...</p>}
        {!loading && theoDoiRaSoatData.data.length === 0 && (
            <Typography sx={{ mt: 2, fontStyle: 'italic' }}>Không có xã nào có lịch thu mẫu trong khoảng ngày này.</Typography>
        )}
        
        {!loading && theoDoiRaSoatData.data.length > 0 && (
          <TableContainer component={Paper} sx={{ mt: 2 }} className="table-wrapper-baocao">
            <Table stickyHeader className="responsive-table-baocao">
              <TableHead>
                 <TableRow>
                  <TableCell rowSpan="2">STT</TableCell>
                  <TableCell rowSpan="2">Tên Xã</TableCell>
                  <TableCell rowSpan="2">Tổng số</TableCell>
                  <TableCell colSpan="6" sx={{textAlign: 'center', background: '#fff8e1'}}>Không thu mẫu đợt này</TableCell>
                  <TableCell rowSpan="2">Tổng cần thu</TableCell>
                </TableRow>
                <TableRow className="sub-header">
                  <TableCell sx={{background: '#fff8e1'}}>KLL</TableCell>
                  <TableCell sx={{background: '#fff8e1'}}>KNC</TableCell>
                  <TableCell sx={{background: '#fff8e1'}}>Ở xa</TableCell>
                  <TableCell sx={{background: '#fff8e1'}}>Thu trước</TableCell>
                  <TableCell sx={{background: '#fff8e1'}}>Dự phòng</TableCell>
                  <TableCell sx={{background: '#fff8e1'}}>Đề nghị xóa</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {theoDoiRaSoatData.data.map((xa, index) => (
                  <TableRow key={xa.xa_id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell sx={{fontWeight: 'bold', textAlign: 'left'}}>{xa.ten_xa}</TableCell>
                    <TableCell>{xa.TongSo}</TableCell>
                    <TableCell>{xa.KhongThu_KLL}</TableCell>
                    <TableCell>{xa.KhongThu_KNC}</TableCell>
                    <TableCell>{xa.KhongThu_OXKV}</TableCell>
                    <TableCell>{xa.KhongThu_Truoc}</TableCell>
                    <TableCell>{xa.KhongThu_DuPhong}</TableCell>
                    <TableCell>{xa.KhongThu_DeNghiXoa}</TableCell>
                    <TableCell sx={{ background: '#eaf8fa' }}>{xa.TongCanThu}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
              {theoDoiRaSoatData.totals && (
                <TableFooter sx={{background: '#e0e0e0', fontWeight: 'bold'}}>
                   <TableRow>
                        <TableCell colSpan={2} sx={{fontWeight: 'bold'}}>TỔNG CỘNG</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>{theoDoiRaSoatData.totals.TongSo}</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>{theoDoiRaSoatData.totals.KhongThu_KLL}</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>{theoDoiRaSoatData.totals.KhongThu_KNC}</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>{theoDoiRaSoatData.totals.KhongThu_OXKV}</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>{theoDoiRaSoatData.totals.KhongThu_Truoc}</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>{theoDoiRaSoatData.totals.KhongThu_DuPhong}</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>{theoDoiRaSoatData.totals.DeNghiXoa}</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>{theoDoiRaSoatData.totals.TongCanThu}</TableCell>
                   </TableRow>
                </TableFooter>
              )}
            </Table>
          </TableContainer>
        )}
      </TabPanel>

      {/* --- TAB 3: DỰ BÁO SỐ MẪU THU --- */}
      {/* (Giữ nguyên) */}
      <TabPanel value={tabValue} index={2}>
         <Typography variant="h6">
            Dự báo số lượng thu mẫu (Theo lịch thu từ {new Date(tuNgay + 'T00:00:00').toLocaleDateString('vi-VN')} đến {new Date(denNgay + 'T00:00:00').toLocaleDateString('vi-VN')})
         </Typography>
         
         {loadingDuBao && <p>Đang tải...</p>}
         
         {!loadingDuBao && duBaoData.length === 0 && (
            <Typography sx={{ mt: 2, fontStyle: 'italic' }}>
              Không có lịch thu mẫu nào trong khoảng ngày đã chọn.
            </Typography>
         )}

         {!loadingDuBao && duBaoData.length > 0 && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableHead sx={{ background: '#f0f0f0' }}>
                <TableRow>
                  <TableCell>Ngày Thu</TableCell>
                  <TableCell>Địa điểm</TableCell>
                  <TableCell>Các xã</TableCell> 
                  <TableCell>Số lượng CHƯA THU (Thực tế)</TableCell>
                  <TableCell>Số lượng Dự kiến (Admin nhập)</TableCell>
                  <TableCell>Hành động</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {duBaoData.map((lich) => (
                  <TableRow key={lich.id}>
                    <TableCell>{new Date(lich.ngay_thu).toLocaleDateString('vi-VN')}</TableCell>
                    <TableCell>{lich.dia_diem}</TableCell>
                    <TableCell sx={{fontSize: '0.8rem'}}>{lich.ten_cac_xa}</TableCell> 
                    <TableCell sx={{fontWeight: 'bold', color: 'red'}}>{lich.soLuongChuaThu}</TableCell>
                    <TableCell sx={{fontWeight: 'bold', color: 'blue'}}>
                      {lich.soLuongDuKien !== null ? lich.soLuongDuKien : '(Chưa thiết lập)'}
                    </TableCell>
                    <TableCell>
                      <Button 
                          variant="outlined" 
                          size="small"
                          onClick={() => handleDuBaoChange(lich.id, lich.ngay_thu, lich.soLuongDuKien)}
                      >
                        Thiết lập
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
         )}
      </TabPanel>
    </Box>
  );
}

export default BaoCao;